module.exports = __webpack_public_path__ + "img/gpic8.png";